import { TIME_ZONE } from './format';

export const E_TRANSFER_EMAIL = 'leaguepay@ftlovolleyball.ca';

export const SCREENSHOT_REQUEST = `📸 Confirmation: Please email ${E_TRANSFER_EMAIL} a screenshot of your completed e-transfer.`;

/** How long an approved team has to pay, counted from the approval email. */
export const PAYMENT_WINDOW_HOURS = 48;

const HOUR_MS = 3_600_000;
const DAY_MS = 24 * HOUR_MS;
/** 3 p.m. in `TIME_ZONE`, a fixed UTC-7, is 22:00 UTC. */
const DEADLINE_UTC_MS = 22 * HOUR_MS;

const deadlineFormatter = new Intl.DateTimeFormat('en-CA', {
  weekday: 'short',
  month: 'short',
  day: 'numeric',
  hour: 'numeric',
  timeZone: TIME_ZONE,
});

/** The first 3 p.m. at least `PAYMENT_WINDOW_HOURS` after `now`, such as `Fri., Nov. 13, 3 p.m.`. */
export function paymentDeadline(now: Date): string {
  const due = now.getTime() + PAYMENT_WINDOW_HOURS * HOUR_MS;
  return deadlineFormatter.format(
    Math.ceil((due - DEADLINE_UTC_MS) / DAY_MS) * DAY_MS + DEADLINE_UTC_MS,
  );
}

export function eTransferMemo({
  season,
  flavour,
  teamName,
  captainName,
  code,
}: {
  season: string;
  flavour: string;
  teamName: string;
  captainName: string;
  code: string;
}): string {
  return [season, flavour, teamName, captainName, code]
    .filter((part) => part !== '')
    .join(' - ');
}
